// import "@babel/polyfill"
// require('es6-object-assign').polyfill();
import Vue from 'vue'
import App from './App.vue'
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import store from './store/index.js';
import VueNativeSock from 'vue-native-websocket'
import VueIntro from 'vue-introjs';



import Vuex from 'vuex';
Vue.use(Vuex);

import VueRouter from 'vue-router';
Vue.use(VueRouter);


import router from './routes'

import vueScrollto from 'vue-scrollto';
Vue.use(vueScrollto);

Vue.use(VueIntro);

import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel);



Vue.use(VueNativeSock, 'ws://127.0.0.1:8000/ws/', {
  connectManually: true,
  format: 'json',
  store: store
});

UIkit.use(Icons);

Vue.config.productionTip = false;


new Vue({
  router,
  render: h => h(App),
  beforeCreate() {
    store.commit('INITIALIZE_STORE')
  },//before create ?
  store: store,
}).$mount('#app')


// Subscribe to store updates
store.subscribe((mutation, state) => {
	// Store the state object as a JSON string
	localStorage.setItem('store', JSON.stringify(state));
});
